/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Check, AlertTriangle, ShieldAlert, Bot, User } from 'lucide-react';
import { cn } from '@/lib/utils';

export const urgencyStyle = {
  low: { cls: 'bg-emerald-100 text-emerald-800 border-emerald-200', icon: Check, label: 'Bassa' },
  medium: { cls: 'bg-amber-100 text-amber-800 border-amber-200', icon: AlertTriangle, label: 'Media' },
  high: { cls: 'bg-red-100 text-red-800 border-red-200', icon: ShieldAlert, label: 'Alta' },
};

/** Pillola "Urgenza: Bassa/Media/Alta". */
export const UrgencyPill = ({ urgency, prefix = '', testId }) => {
  const b = urgencyStyle[urgency] || urgencyStyle.low;
  const Ic = b.icon;
  return (
    <span className={cn('inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold', b.cls)} data-testid={testId}>
      <Ic className="h-3 w-3" /> {prefix}{b.label}
    </span>
  );
};

const RoleAvatar = ({ Icon }) => (
  <div className="h-7 w-7 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
    <Icon className="h-4 w-4 text-primary" />
  </div>
);

/** Singola bolla di chat (assistente a sinistra, utente a destra). */
export const TriageMessage = ({ m, idx }) => {
  const isUser = m.role === 'user';
  return (
    <div className={cn('flex gap-2', isUser ? 'justify-end' : 'justify-start')}>
      {!isUser && <RoleAvatar Icon={Bot} />}
      <div
        className={cn(
          'max-w-[80%] px-3 py-2 rounded-2xl text-sm whitespace-pre-wrap leading-relaxed',
          isUser ? 'bg-primary text-primary-foreground rounded-br-sm' : 'bg-muted text-foreground rounded-bl-sm',
        )}
        data-testid={`triage-msg-${m.role}-${idx}`}
      >
        {m.content}
      </div>
      {isUser && <RoleAvatar Icon={User} />}
    </div>
  );
};
